import { data } from '../../svg/Account/data';
import { makeIcon } from '../makeIcon';

export const Account = makeIcon(data, 'account', 'Account');

export default Account;
